import SignaturePad from "./SignaturePad";

export default function SignatureModal({
    open,
    onClose,
    onSave,
}) {
    if (!open) return null;

    return (
        <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">

            <div className="bg-white rounded-xl w-full max-w-xl p-6">

                <h2 className="text-xl font-semibold mb-4">
                    Sign Below
                </h2>

                <SignaturePad
                    required
                    onChange={(signature) => {
                        onSave(signature);
                        onClose();
                    }}
                />

                <button
                    onClick={onClose}
                    className="mt-5 text-gray-600"
                >
                    Cancel
                </button>

            </div>

        </div>
    );
}